export const rqKeys = {
  phoneToCall: 'phoneToCall',

  userData: 'userData',
  userBalance: 'userBalance',
  userCards: 'userCards',
  userCardBalance: 'userCardBalance',
  userCardBalanceRev: 'userCardBalanceRev',

  certificatesList: 'certificatesList',
  certificateCategoriesList: 'certificateCategoriesList',
  certificatesNominalsList: 'certificatesNominalsList',
  certificatesRest: 'certificatesRest',

  gasStationKey: 'gasStationKey',
  fuelInfo: 'fuelInfo',

  orderStatusKey: 'orderStatusKey',
  transactionsKey: 'transactionsKey',

  withdrawalList: 'withdrawalList',
  withdrawalHistoryKey: 'withdrawalHistoryKey',

  documents: 'documents',
  documentContent: 'documentContent',
  categories: 'categories',
  becoms: 'becoms',

  instructions: 'instructions',

  shareholderAddressList: 'shareholderAddressList',

  ticketsList: 'ticketsList',
  ticketsCategories: 'ticketsCategories',
  ticketConversation: 'ticketConversation',
  visitorMessageTopics: 'visitorMessageTopics',
  visitorMessageTopicList: 'visitorMessageTopicList',
  visitorMessageUnread: 'visitorMessageUnread',

  newsList: 'newsList',
  newsArticle: 'newsArticle',

  storeGoodsList: 'storeGoodsList',
  waitingChecks: 'waitingChecks',
}
